//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    location: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      open: true,
      species: [],
    };
  },
  watch: {
    species() {
      if (this.index !== null) {
        this.$emit('updateSpecies', this.index, this.species);
      } else {
        this.$emit('updateSpecies', this.species);
      }
    },
  },
  mounted() {
    if (this.location.species) {
      this.species = this.location.species;
    }
  },
};
